"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProjectRulesAgreementSignatureApi = void 0;
exports.createProjectRulesAgreementSignatureApi = (axios) => ({
    signProjectRulesAgreement({ projectId, signature, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`/project/${projectId}/signatures`, { signature }))
                .data;
        });
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdFJ1bGVzQWdyZWVtZW50U2lnbmF0dXJlQXBpLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FwaS9wcm9qZWN0UnVsZXNBZ3JlZW1lbnRTaWduYXR1cmVBcGkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBR2EsUUFBQSx1Q0FBdUMsR0FBRyxDQUNyRCxLQUFvQixFQUNwQixFQUFFLENBQUMsQ0FBQztJQUNFLHlCQUF5QixDQUFDLEVBQzlCLFNBQVMsRUFDVCxTQUFTLEdBSVY7O1lBQ0MsT0FBTyxDQUFDLE1BQU0sS0FBSyxDQUFDLElBQUksQ0FBQyxZQUFZLFNBQVMsYUFBYSxFQUFFLEVBQUUsU0FBUyxFQUFFLENBQUMsQ0FBQztpQkFDekUsSUFBSSxDQUFDO1FBQ1YsQ0FBQztLQUFBO0NBQ0YsQ0FBQyxDQUFDIn0=